/**
 * Zahlungsintervall um die eine Mitgliedschaft automatisch verlängert werden soll.
 */
export enum MembershipRenewInterval {
   /**
    * Jährlich
    */
   annual = "annual",

   /**
    * Halbjährlich
    */
   biannual = "biannual",

   /**
    * Nicht automatisch verlängern
    */
   none = "none",
}

export const MembershipRenewIntervalNames = {
   annual: "jährlich",
   biannual: "halbjährlich",
   none: "Keine"
};